import { EVENTS_WEB_API_BASE } from './endpoints';
export class EventsHttpClient {
    constructor(httpClient, baseUrl = EVENTS_WEB_API_BASE, linguisticHeader) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.linguisticHeader = linguisticHeader;
        this.getHeaders = () => {
            return {
                headers: { 'x-wix-linguist': this.linguisticHeader },
            };
        };
        this.makeRequest = ({ url, method, data = {}, }) => {
            return this.httpClient
                .request(Object.assign({ url: `${this.baseUrl}${url}`, method,
                data }, this.getHeaders()))
                .then(response => response.data);
        };
    }
    get(url) {
        return this.makeRequest({ url, method: 'GET' });
    }
    delete(url, data) {
        return this.makeRequest({ url, method: 'DELETE', data });
    }
    put(url, data) {
        return this.makeRequest({ url, method: 'PUT', data });
    }
    post(url, data) {
        return this.makeRequest({ url, method: 'POST', data });
    }
    patch(url, data) {
        return this.makeRequest({ url, method: 'PATCH', data });
    }
}
//# sourceMappingURL=http-client.js.map